module.exports = __webpack_public_path__ + "static/media/raccoon2-min.b1b740e9.png";